import Swiper from "swiper/bundle";

class UmSlider extends HTMLElement {
   constructor() {
      super();
      // this.attachShadow({ mode: 'open' });
      let children = [...this.children];

      const swiper = document.createElement('div');
      swiper.setAttribute("class", `swiper`);

      const wrapper = document.createElement('div');
      wrapper.setAttribute("class", `swiper-wrapper`);

      for (var i = 0; i < children.length; i++) {
        const child = children[i]
        const slide = document.createElement('div');
        slide.setAttribute("class", `swiper-slide`);
        slide.appendChild(child)
        wrapper.appendChild(slide)
      }

      const prev = document.createElement('div');
      prev.setAttribute("class", `slider-prev`);

      const next = document.createElement('div');
      next.setAttribute("class", `slider-next`);

      swiper.appendChild(wrapper);
      this.append(swiper, prev, next);

      this.swiper = new Swiper(swiper, {
        slidesPerView: 1.1,
        spaceBetween: 15,
        speed: 700,
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
      });
   }

}

customElements.define('um-slider', UmSlider);
